import styled from "styled-components";
import CheckboxCheckmark from "./CheckboxCheckmark";

export default styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;

  &:checked ~ ${CheckboxCheckmark} {
    border: 1px solid #ff5d4c;
    background-color: #fff;
    color: #ff5d4c;
  }
`;
